export default {
  title: 'Descontos/Encargos globais antes de impostos'
}